export enum ShrimpDeadAmountUnit {
  Count = 'count',
  Kg = 'kg',
}

export const DISEASE_OTHER = "อื่นๆ"